import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class StarIcon extends Component {
    static propTypes = {
        fill: PropTypes.string,
        className: PropTypes.string
    };

    static defaultProps = {
        fill: '#a6b0bd'
    };

    render() {
        const {fill, className} = this.props;
        const stroke = this.props.stroke || fill;

        return (
            <svg width="19" height="18" viewBox="0 0 19 18" className={className}>
                <g fill="none" fillRule="evenodd" clipPath="">
                    <path fill={stroke}
                          fillRule="nonzero"
                          d="M11.69 7.196a1 1 0 0 1-.751-.549l-1.66-3.38-1.661 3.38a1 1 0 0 1-.753.549l-3.724.547 2.697 2.639a1 1 0 0 1 .287.883l-.635 3.721 3.321-1.755a1 1 0 0 1 .934 0l3.322 1.755-.636-3.721a1 1 0 0 1 .287-.883l2.697-2.64-3.724-.546zm6.012-1.14a1 1 0 0 1 .554 1.705l-3.765 3.684.889 5.205a1 1 0 0 1-1.453 1.053l-4.649-2.456-4.649 2.456a1 1 0 0 1-1.452-1.053l.888-5.205L.301 7.76a1 1 0 0 1 .554-1.704l5.2-.764L8.38.56a1 1 0 0 1 1.795 0l2.326 4.734 5.2.764z"/>
                    <path fill={fill}
                          d="M11.836 6.206l5.72.84-4.139 4.05.977 5.722-5.116-2.702-5.116 2.702.977-5.721L1 7.047l5.72-.84L9.278 1z"/>
                </g>
            </svg>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/assets/icons/StarIcon.js